import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { defaultOptions } from "./configs";
import { determineEnvironment } from "@cultureamp/frontend-env";
import { getClientSideID, transformContext } from "../../common";
/**
 * This is an async function which initializes the SDK at the entry point and
 * awaits it so all flags are ready before the consumer app is rendered. This
 * ensures your app does not flicker due to flag changes at startup time. With
 * asynchronous provider, the rendering of React app is delayed until
 * initialisation is completed and initialisation cannot be deferred.
 *
 * @param config - The configuration used to initialize SDK
 * @returns A React Function Component which saves all flags and the client
 * instance in the context API and subscribes to flag changes and propagate them
 * through the context API.
 */
export async function asyncWithProvider(config) {
    let clientSideID = "UNAVAILABLE";
    const { context = { type: "user" }, reactOptions = { ...defaultOptions }, options, flags, } = config;
    try {
        clientSideID = config.clientSideID ?? (await getClientSideID());
    }
    catch (err) {
        /**
         * We omit the error in local development, where engineers commonly run the
         * app without a LaunchDarkly client ID, on fallback values.
         */
        if (determineEnvironment().realm !== "localhost") {
            console.error("LaunchDarkly - Unable to retrieve client-side ID! Fallback values will be used.");
        }
        if (options != undefined) {
            options.streaming = false;
            options.sendEvents = false;
            options.fetchGoals = false;
        }
    }
    return asyncWithLDProvider({
        clientSideID,
        context: transformContext(context),
        options,
        reactOptions: { ...defaultOptions, ...reactOptions },
        flags,
    });
}
